// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__Q6A0t","large":"styles_large__2niHi"};